import React, {Fragment, useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Form,Button,Spinner,} from 'react-bootstrap';
import axios from 'axios';
import Recepisse from '../../components/RecepisseDepot/index'
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import { InputOption } from '../../components/Input';
import Alert, { Alert2 } from '../../components/Alerte';
import Update from '../Update/index';
import { useNavigate } from 'react-router-dom';
import './recrutement.css';
import Env from '../../hooks/Env';
// ...existing code...
const renderTooltip = (props) => (
    <Tooltip id="button-tooltip"  {...props}>
      Ajouter un nouveau fichier
    </Tooltip>
  );
  const IconForFile = (props) => {
    return (
        <>
        <OverlayTrigger
            placement="right"
            delay={{ show: 100, hide: 400 }}
            overlay={renderTooltip}
            >
            <FontAwesomeIcon onClick={() => {props.toggleInputVisibility(props.name)}} icon={faFile} className='btn btn-primary mr-2' />
        </OverlayTrigger>
        </>
    )
  }
const Depot = ({props}) => {
    const API_URL = Env().API_URL ;
    console.log(API_URL)
    const [InputVisible, SetInputVisible] = useState({})
    const toggleInputVisibility = (state) => {
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
    }
    
    const removeFile = (fieldName,state) => {
        console.log("Au moment ",selectedFiles.publication7)
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
        // Créez une copie de l'état actuel
        const updatedFiles = { ...selectedFiles };
      
        // Supprimez l'élément spécifique
        updatedFiles[fieldName] = null;
      
        // Mettez à jour l'état avec la nouvelle copie
        setSelectedFiles(updatedFiles);
        console.log("Aprés mise à jour ",selectedFiles.publication7)
      };
    const [dataForm, setDataForm] = useState({
        type_poste: 'ETU',
        poste: 'Moniteur Centre des Langues',
    });
    const [nationalities, setNationalities] = useState([]);
    const [step, setStep] = useState(1);
    const [update,setUpdate] = useState(false)
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const [message, setMessage] = useState('')
    const [typefille, setTypeFile] = useState(false)
    const[ messageAlerte, setMessageAlerte] = useState('')
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const maxFileSize = 1024 * 1024 * 2; //1Mo
    const [show, setShow] = useState(false);
    const [complete, setComplete] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "cv": true,
        "lettre_motivation": true,
        "copie_diplome": true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "cv": false,
        "lettre_motivation": false,
        "copie_diplome": false,
    });
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        // console.log(selectedFiles.publication7)
        var file = event.target.files[0];
            const elements = document.getElementsByName(key)
            if (file?.size < maxFileSize){
                setTypeFile(false)
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: file
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: true
                }));
                for (var i = 0; i < elements.length; i++) {
                    var element1 = elements[i];
                    // console.log(element)
                    // Faites quelque chose avec chaque élément, par exemple :
                    element1.style.border = ""; // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }
            } else {
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                for (var j = 0; j < elements.length; j++) {
                    var element = elements[j];
                    // console.log(element)
                    // Faites quelque chose avec chaque élément, par exemple :
                    element.style.border = "2px solid #BC0C0C";
                    element.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }

            }
    };
    // const navigate = useNavigate('')
      useEffect(() => {
        // navigate('/')  //pour forcer la redirection au cas ou 
        // const fetchNationalities = async () => {
        //     try {
        //       const response = await fetch('https://restcountries.com/v3.1/all');
        //       if (!response.ok) {
        //         throw new Error('Unable to fetch nationalities.');
        //       }
        //       const data = await response.json();
        //       let nationalities = data.map(country => country.name.common);
        //       nationalities = nationalities.sort()
        //       setNationalities(nationalities)
        //       return nationalities;
        //     } catch (error) {
        //       console.error('Error fetching nationalities:', error);
        //       return [];
        //     }
        //   };
        //   fetchNationalities()
      },[dataForm.type_poste]) 
      // Exemple d'utilisation
    function handleChange (e) {
        const name= e.target.name;
        let value = e.target.value;
        // console.log(value,name)
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
        // console.log(value,name)
    }
    const handleNextStep = () => {
        if (step === 1) {
           if (!dataForm.email || !dataForm.civilite || !dataForm.prenom|| !dataForm.nom || !dataForm.date_naissance || !dataForm.lieu_naissance || !dataForm.telephone || !dataForm.address) {
                setErrors(true)
           } else if (!valid.isValidPhoneNumber) {
            setMessageAlerte('Format du numéro incorrect')
        }
           
           else {
                setErrors(false)
                setStep(step + 1)
           }
            
        } else if (step === 2) {
            setStep(step + 1);
            // console.log(dataForm.type_poste,dataForm.poste,dataForm.ecole_postulee,dataForm.annee_experience,dataForm.pays,dataForm.diplome)
            if (dataForm.type_poste === 'PER') {
                if (dataForm.type_poste && dataForm.poste && dataForm.ecole_postulee && dataForm.annee_experience && dataForm.pays && dataForm.diplome) {
                //    setErrors(false);
                    // setStep(step + 1);
                   } else {
                        // setErrors(true);
                }   
            } else {
                if (dataForm.poste==="Executive Coaching") {
                    console.log(dataForm.poste,dataForm.annee_experience)
                    dataForm.annee_experience = 1;
                }
                if (dataForm.type_poste && dataForm.poste && dataForm.annee_experience && dataForm.pays && dataForm.diplome) {
                  //  setErrors(false);
                  //  setStep(step + 1);
                } else {
                  //  setErrors(true);
                }
            }
            
        }
    };
  
    const handlePreviousStep = () => {
      setStep(step - 1);
    };
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData();
            const nameFiles = ["cv", "lettre_motivation", "copie_diplome"]
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]]) {
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                        // console.log("fichier trop gros");
                    }
                }
            }
            for (let key in dataForm) {
                // console.log(dataForm[key])
                if (dataForm.hasOwnProperty(key)) {
                      if( dataForm[key] !== null) {
                        // if (key === 'pays') {
                        //     if (dataForm['type_poste'] === 'PATS') {
                        //         if (dataForm['pays'] !== 'senegal') {
                        //             dataForm['pays'] = 'SENEGAL'
                        //         }
                        //     }
                        // }
                        formData.append(key ,dataForm[key])
                      }
              }
            }
            var showALerte = nameFiles.some(field => selectedFiles[field] === false);
        //  for (let pair of formData.entries()) {
        //         console.log(pair[0] + ':' + pair[1]);
        //       }
            if (!valid.isValidPhoneNumber) {
                setMessageAlerte('Incorrect')
                setShow(true);
            
            }
            else if (showALerte) {
                 setShow(true);
                //  setOk(false)
            }
            else if (typefille) {
                alert('format de fichier incoorecte !')
            }
            else {
                setComplete(true)
                setSubmitted(true);
                // console.log("Requete en cours d'envoi ...")
                const response = await axios.post(
                    `${API_URL}/recrutement/`,
                    formData,
                    {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });
            // console.log(response)
            if (response.status === 200) {
                if (response.data.detail) {
                    setSubmitted(false);
                    // console.log(response.data.detail)
                    setDeppotSuccess2(true)
                } else {
                    // console.log(response)
                    setSubmitted(false);
                    // console.log('Files uploaded successfully');
                    // console.log('Recepissé :' + response?.data?.data)
                    const dataPersonDepot = response?.data?.data;
                    setData(dataPersonDepot);
                    setDeppotSuccess(true);
                    // console.log("message : " + response.data.message);
                    // console.log(data);
                }
            } else {
                console.error('Error uploading files');
                console.log("Détail de la réponse ",response.status)
            }
        }
    } catch (error) {
        setSubmitted(false);
       console.error('Error', error);
    }
};
    const calculateProgress = () => {
        // Calculez le pourcentage de progression en fonction du numéro d'étape
        return (step / 3) * 100; // Supposons que vous ayez 3 étapes au total
      };
    function handleUpdate () {
        update ? setUpdate(false) : setUpdate(true)
        
    }
  return (
    <>
    <Alert show={show} handleClose={handleClose} />
    {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }
    {depotsuccess ? <Recepisse  dataPerson={data}/> : null}
    {update ? <Update /> : null}
    <div>
        <div className='ml-2 mt-2' style={{display:'flex','justifyContent':'right'}}>
            <Button variant='success' className=' p-2' onClick={handleUpdate}>Modifier son dossier </Button> 
            {/* <Button variant='success' className=' p-1 '>Supprimer  son dossier </Button>*/}
        </div>
    </div>
      <div className='container mb-2 ' id='mainDepot'>
        {/* {step 1 } */}
        <div className='row'>
            <div className="progress mb-1" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
            <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${calculateProgress()}%` }} ></div>
            </div>
        <div id='nameModule' className=''>
            <div>
                <p> {step===1 ? 'Informations personnelles' : '' }</p>
                <p> {step===2 ? 'Documents à fournir' : '' }</p>
            </div>
        </div>
            <div id='form' className={`step step-${step}`}>
            <Form onSubmit={handleSubmit}>
            <div>
                {step === 1 && (
                    <div id="step1" className='mb-3'>
                        <Input type='email' focus={true} value={dataForm.email || ''} label="Email" name='email' onChange={handleChange} />
                        <Form.Group>
                            <div className='d-inline'>
                                <Form.Check
                                inline
                                        type="radio"
                                        label="Monsieur"
                                        value='Monsieur'
                                        required
                                        checked = {dataForm.civilite === 'Monsieur'}
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='d-inline'>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Madame"
                                        value='Madame'
                                        checked = {dataForm.civilite === 'Madame'}
                                        required
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                            </Form.Group>
                            <div className='row' id='test'>
                            <Input className="col-md-6 col-sm-12" value={dataForm.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                            <Input className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Nom" name='nom' onChange={handleChange}/>
                            </div>
                            <div className='row'>
                                <Input className="col-md-6 col-sm-12" value={dataForm.date_naissance || ''} type='date' label="Date de Naissance" name='date_naissance' onChange={handleChange} />
                                <Input className="col-md-6 col-sm-12" value={dataForm.lieu_naissance || ''} type='text' label="Lieu de naissance" name='lieu_naissance' onChange={handleChange} />
                            </div> 
                            <InputT type='number' value={dataForm.telephone || ''} label="Téléphone"  name='telephone' onChange={handleChange} />
                            {!valid.isValidPhoneNumber ? <span style={{color:'red'}}>{messageAlerte} </span>: null}
                            <Input type='text' value={dataForm.address || ''} label="Adresse" name='address' onChange={handleChange} />
                    </div>
                )}
                {step === 2 && (
                <div className='mb-3'>
                    <InputF required={true} className="rounded-left mb-2" label="CV" type='file' message={<span style={{color:'red'}}>*</span>} name='cv' onChange={(e) => handleFileChange(e,"cv")} />
                    {!selectedFiles["cv"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    <InputF required={true} className="rounded-left mb-2" label="Lettre de motivation" type='file' message={<span style={{color:'red'}}>*</span>} name='lettre_motivation' onChange={(e) => handleFileChange(e,"lettre_motivation")} />
                    {!selectedFiles["lettre_motivation"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    <InputF required={true} className="rounded-left mb-2" label="Une copie de votre relevé de notes le plus récent" type='file' message={<span style={{color:'red'}}>*</span>} name='copie_diplome' onChange={(e) => handleFileChange(e,"copie_diplome")} />
                    {!selectedFiles["copie_diplome"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                </div>
                )}
           </div>
           {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuiler remplir tous les champs
                            </div></> : null}
           <div className="buttons">
            {step > 1 && (
                <Button variant='primary' className='float-start mb-2' size="md" onClick={handlePreviousStep}>Précedent</Button>
            )}
            {step < 2 && (
                <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
            )}
            {step === 2 && 
                <Button  variant="primary" type='submit' size="md"
                    className="p-2 float-end mb-2">
                    Valider  {submitted ?
                        <Spinner animation="grow"
                        size="sm" role="status"
                        >
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        : null}
                </Button>
            }
            </div>
          </Form>
        </div>
        </div>
      </div>
    </>
  )
}
export default Depot